module.exports = __webpack_public_path__ + "static/media/snowy-1.f78cba60.svg";